// No test coverage: lazy re-export wrappers with no testable logic (reload behaviour tested in lazy-utils)
import { lazyWithReload } from '@/utils/lazy-utils.ts';

/* eslint-disable promise/prefer-await-to-then */
export const LazyDashboardView = lazyWithReload(() =>
    import('@/pages/dashboard-view.tsx').then((m) => ({ default: m.DashboardView }))
);
export const LazyPlaygroundPage = lazyWithReload(() =>
    import('@/pages/playground-page.tsx').then((m) => ({ default: m.PlaygroundPage }))
);
export const LazyMagicLinkPage = lazyWithReload(() =>
    import('@/pages/magic-link-page.tsx').then((m) => ({ default: m.MagicLinkPage }))
);
export const LazyDemoLoginPage = lazyWithReload(() =>
    import('@/pages/demo-login-page.tsx').then((m) => ({ default: m.DemoLoginPage }))
);
export const LazyRecallPage = lazyWithReload(() =>
    import('@/pages/recall-page.tsx').then((m) => ({ default: m.RecallPage }))
);
export const LazyExtractionPage = lazyWithReload(() =>
    import('@/pages/doc-extraction-page.tsx').then((m) => ({ default: m.DocExtractionPage }))
);
export const LazyAssistantsPage = lazyWithReload(() =>
    import('@/pages/connect/assistants-page.tsx').then((m) => ({ default: m.AssistantsPage }))
);
export const LazyAssistantFormPage = lazyWithReload(() =>
    import('@/pages/connect/assistant-form-page.tsx').then((m) => ({ default: m.AssistantFormPage }))
);
/* eslint-enable promise/prefer-await-to-then */
